import * as stylex from '@stylexjs/stylex'
import { Box } from '../Box/Box'
import { Container, type ContainerProps } from '../Container/Container'
import { Paper, type PaperProps } from '../Paper/Paper'

const baseStyles = stylex.create({
  root: {
    padding: 12,
    borderRadius: 0,
  },
})

export interface FooterProps extends PaperProps<'div', HTMLElement> {
  /**
   * 頁尾樣式變體：normal（帶陰影）、transparent（透明背景）
   * @default 'normal'
   */
  variant?: 'normal' | 'transparent'
  /** 傳遞給內部 Container 元件的 props */
  ContainerProps?: ContainerProps
}

/**
 * Footer 是頁尾元件，支援一般（帶陰影）與透明兩種樣式。
 * 內部自動使用 Container 限制最大寬度。
 */
export const Footer = (props: FooterProps) => {
  const { rootStyle: rootStyleProp, children, variant = 'normal', ContainerProps, ...rest } = props
  const isTransparent = variant === 'transparent'
  const rootStyle = [baseStyles.root, rootStyleProp]

  if (isTransparent) {
    return (
      <Box rootStyle={rootStyle} pointerEvents="none" {...rest}>
        <Container display="flex" {...ContainerProps}>
          <Box display="inline-flex" pointerEvents="auto">{children}</Box>
        </Container>
      </Box>
    )
  }

  return (
    <Paper
      rootStyle={rootStyle}
      elevation={8}
      shadowDirection="top"
      {...rest}
    >
      <Container display="flex" {...ContainerProps}>
        {children}
      </Container>
    </Paper>
  )
}
